const CustomFormat = {
    mesesAno: [
      'Jan',
      'Fev',
      'Mar',
      'Abr',
      'Mai',
      'Jun',
      'Jul',
      'Ago',
      'Set',
      'Out',
      'Nov',
      'Dez',
    ],
    removeMoneyFormat: function (value) {
        if (value)
            return parseFloat(value.replace('R$ ', '').replace(/(\.)/g, '').replace(',', '.'));
        else
            return undefined;
    },
    removePercentFormat: function (value) {
        if (value)
            return parseFloat(value.replace(' %', '').replace(/(\.)/g, '').replace(',', '.'));
        else
          return undefined;
    },
    virgulaParaPonto: function (value) {
      if (value)
        return parseFloat(value.replace(',', '.'));
      else
        return undefined;
    },
    pontoParaVirgula: function (value) {
      if (value)
        return value.toString().replace(/(\.)/g, ',');
      else
        return undefined;
    },
    toMoneyString: function (value) {
        if (value)
            return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' });
        else
          return undefined;
    },
    toPercentString: function (value) {
        if (value)
          return value.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) + ' %';
        else
          return undefined;
    },
    toPercentTaxaString: function (value) {
        if (value || value == 0)
            return value.toLocaleString('pt-BR', { minimumFractionDigits: 3 }) + ' %';
        else
          return undefined;
    },
    toLocaleDateString: function (value) {
        if (value)
            return (new Date(value)).toLocaleDateString('pt-br', { timeZone: 'UTC' });
        else
          return undefined;
    },
    parseDateToFormatedString: function (value) { //De aaaa-mm-dd para dd/mm/aaaa
        if (value) {
            const [ano, mes, dia] = value.toString().split('-');
            return `${dia}/${mes}/${ano}`;
        } else
          return undefined;
    },
    parseDateToFormatedStringWithMonthName: function (value) { //De aaaa-mm-dd para dd/mm/aaaa
      if (value) {          
          const [ano, mes, dia] = value.toString().split('-');
          return `${dia} ${this.mesesAno[mes-1]}`;
      } else
        return undefined;
  },
    parseDateToInt: function (value) { //De aaaa-mm-dd para um int aaaammdd
        if (value) {
            const [ano, mes, dia] = value.toString().split('-');
            return parseInt(ano + mes + dia);
        } else
          return undefined;
    },
    parseFormatedDateToInt: function (value) { //De dd/mm/aaaa para um int aaaammdd
        if (value) {
            const dateOnly = value.substring(0, 10);
            const [dia, mes, ano] = dateOnly.split('/');
            return parseInt(ano + mes + dia);
        } else
          return undefined;
    },
    parseFormatedDateTimeToInt: function (value) { //De 'dd/mm/aaaa hh:mm:ss' para um int aaaammddhhmmss
        if (value) {
            const dateOnly = value.substring(0, 10);
            const [dia, mes, ano] = dateOnly.split('/');
            const timeOnly = value.substring(11, 19);
            const [hora, minuto, segundo] = timeOnly.split(':');
            return parseInt(ano + mes + dia + hora + minuto + segundo);
        } else
          return undefined;
    },
    toLocaleDateTimeString: function (value) {
        if (value) {
            return (new Date(value)).toLocaleString('pt-br');
        } else
          return undefined;
    },
    removerAcentos: function(text) {
      text = text.toLowerCase();                                                         
      text = text.replace(new RegExp('[ÁÀÂÃÄ]','gi'), 'a');
      text = text.replace(new RegExp('[ÉÈÊË]','gi'), 'e');
      text = text.replace(new RegExp('[ÍÌÎÏ]','gi'), 'i');
      text = text.replace(new RegExp('[ÓÒÔÕÖØ]','gi'), 'o');
      text = text.replace(new RegExp('[ÚÙÛÜ]','gi'), 'u');
      text = text.replace(new RegExp('[Ç]','gi'), 'c');
      return text;
    },
    localDateTimeToFormattedString: function(date) {
      if (date) {
        const hour = date.time.hour.toString().length == 1 ? `0${date.time.hour}` : date.time.hour;
        const minute = date.time.minute.toString().length == 1 ? `0${date.time.minute}` : date.time.minute;
        return `${date.date.day}/${date.date.month}/${date.date.year} ${hour}:${minute}`;
      } else {
        return '';
      }
    },
    formatarCnpj: function(cnpj) {
      if (cnpj.length == 14) {
        return `${cnpj.substring(0, 2)}.${cnpj.substring(2, 5)}.${cnpj.substring(5, 8)}/${cnpj.substring(8, 12)}-${cnpj.substring(12, 14)}`;
      } else {
        return cnpj;
      }
    },
    formatarCep: function(cep) {
      if (cep.length == 8) {
        return `${cep.substring(0, 5)}-${cep.substring(5, 8)}`;
      } else {
        return cep;
      }
    },
    formatarTelefoneSemDdd: function(telefone) {
      if (telefone.length == 8) {
        return `${telefone.substring(0, 4)}-${telefone.substring(4, 8)}`;
      } else if (telefone.length == 9) {
        return `${telefone.substring(0, 5)}-${telefone.substring(5, 9)}`;
      } else {
        return telefone;
      }
    }
}

export default CustomFormat


// WEBPACK FOOTER //
// ./src/helpers/custom-format.js